import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import './Layout.scss';

const Layout = (props) => { 
  return (
    <div>
      <Navbar />
      <div role="main"> {props.children} </div>
      <Footer />
    </div>
  );
}

export default Layout;
